<template>
    <div
        v-cloak
        ref="code"
        class=""
    >
        <slot name="test" />
        <slot name="code" />
    </div>
</template>
<script>
export default {
    name: 'DebuggingTool'
};
</script>
<style lang="scss" scoped>
.hide-onload {
    display: none;
}
</style>
